import { ref } from 'vue';

// 规则弹窗状态
const rulePopupVisible = ref(false);
const rulePopupContent = ref('');

/**
 * 规则弹窗 Composable
 * 用于全局管理规则弹窗的显示状态和内容
 */
export function useRulePopup() {
  /**
   * 显示规则弹窗
   * @param content - 可选的规则文案内容，如果不传则使用默认语言包内容
   */
  const showRulePopup = (content?: string) => {
    window.activityDataLayer.push({
      eventName: "show_popup",
      eventType: "规则弹窗",
      aid: window.activity_name,
      gameId: window.game_id,
    });
    if (content) {
      rulePopupContent.value = content;
    }
    rulePopupVisible.value = true;
  };

  /**
   * 隐藏规则弹窗
   */
  const hideRulePopup = () => {
    rulePopupVisible.value = false;
    // 延迟清空内容，等动画结束
    setTimeout(() => {
      rulePopupContent.value = '';
    }, 300);
  };

  return {
    rulePopupVisible,
    rulePopupContent,
    showRulePopup,
    hideRulePopup
  };
}

